import React from 'react';
import { Button } from '@planne-software/uni/Button';
import { IconArrowRight } from '@planne-software/uni/icons';

import { useTranslate } from '@src/core/hooks';
import { SecurePurchaseNote } from '@src/common/ui/SecurePurchaseNote';

import { CardFormActions, SubmitWrapper } from '../styles';

type CardPaymentActionsProps = {
  canSubmit: boolean;
  submitting: boolean;
};

export const CardPaymentActions = (props: CardPaymentActionsProps) => {
  const { canSubmit, submitting } = props;
  const { i18n } = useTranslate();

  return (
    <CardFormActions data-testid='card-form-actions'>
      <SecurePurchaseNote label={i18n('checkout_secure_purchase')} />

      <SubmitWrapper>
        <Button
          type='submit'
          loading={submitting}
          disabled={!canSubmit || submitting}
          endSlot={<IconArrowRight aria-hidden />}
        >
          {i18n('checkout_payment_card_submit')}
        </Button>
      </SubmitWrapper>
    </CardFormActions>
  );
};

export default CardPaymentActions;
